module.exports = __webpack_public_path__ + "img/js.7295ad28.png";